import { useState } from "react";

/**
 * 角色过滤相关状态 Hook
 */
const useRoleFilterState = () => {
  const [activeRoleFilter, setActiveRoleFilter] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [resetProgressHistory, setResetProgressHistory] = useState(false); // 用于触发进度条历史重置

  // 重置角色过滤状态
  const resetRoleFilterState = () => {
    setActiveRoleFilter(null);
    setExpandedGroups({});
    setResetProgressHistory(false);
  };

  return {
    activeRoleFilter,
    setActiveRoleFilter,
    expandedGroups,
    setExpandedGroups,
    resetProgressHistory,
    setResetProgressHistory,
    resetRoleFilterState,
  };
};

export default useRoleFilterState;
